import React, { useCallback, useState } from 'react';
import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import Visibility from '../../components/Visibility';
import { SubTitle, Image, Description } from '../../components/layouts';
import '../section_portrait_1/style.scss';
import { buildImageURL, getTrack } from '../../helpers';

const IMAGE = buildImageURL('/s9-1.jpg');

const track = getTrack({ block: 8 });

export function NightGallery1() {
  const [mobile, setMobile] = useState(false);
  const progress = useMotionValue(0);
  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      setMobile(width <= 750);
      progress.set(percentagePassed);
    },
    [progress, setMobile]
  );

  const o1 = useTransform(progress, [0.125, 0.4], [0, 1]);
  const y1 = useTransform(progress, [-0.5, 0.2], ['10%', '0%']);
  const y1m = useTransform(progress, [-0.5, 0.4], ['10%', '0%']);

  const o2 = useTransform(progress, [0, 0.1, 0.4], [0.1, 0.3, 1]);
  const y2 = useTransform(progress, [0, 0.4], [10, 0]);
  const scale = useTransform(progress, [0, 0.4], [0.9, 1]);
  const scaleM = useTransform(progress, [0, 0.4], [0.8, 1]);

  const o3 = useTransform(progress, [0.125, 0.4], [0, 1]);
  const y3 = useTransform(progress, [0.125, 0.4], ['25%', '0%']);

  const imgStyle = mobile ? {} : { width: '50vw' };
  return (
    <Visibility
      offset={[-1000, 0]}
      onUpdate={handleUpdate}
      className="page-section section-night-gallery section-portrait inverted"
      data-track={track}
    >
      <div className="sticky-content" style={{ overflow: 'visible' }}>
        <div className="section-content left" style={{ width: mobile ? 960 : '50vw' }}>
          <motion.div className="picture left" style={{ opacity: o2, y: y2, scale: mobile ? scaleM : scale }}>
            <motion.div style={{ opacity: o1, y: mobile ? y1m : y1 }}>
              <SubTitle>超逆光夜景人像</SubTitle>
            </motion.div>
            <motion.div style={{ opacity: o3, y: y3 }}>
              <Description className="small left">
                你的美，不分昼夜。黑夜C位非你莫属。等效50mm专业人像镜头搭配夜景优化，让你的美在黑夜中也能轻松被聚焦。
              </Description>
            </motion.div>
            <Image src={IMAGE} className="gallery-image" paddingBottom="73.2653%" style={imgStyle} />
          </motion.div>
        </div>
      </div>
    </Visibility>
  );
}

